import React from 'react';
import ExternalLink from './ExternalLink';

const customerCreateAccountUrl = `${process.env.REACT_APP_ACCOUNTS_URL}${process.env.REACT_APP_ENDPOINT_ACCOUNT_CREATE}`;

const SignUp = () => (
  <p className="main__sign-up">
    {'New? '}
    <ExternalLink url={customerCreateAccountUrl} target="_self">
      Create an account
    </ExternalLink>
  </p>
);

export default SignUp;
